import { render, staticRenderFns } from "./TrialLabsBarChart.vue?vue&type=template&id=807d04da&scoped=true"
import script from "./TrialLabsBarChart.vue?vue&type=script&lang=js"
export * from "./TrialLabsBarChart.vue?vue&type=script&lang=js"
import style0 from "./TrialLabsBarChart.vue?vue&type=style&index=0&id=807d04da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807d04da",
  null
  
)

export default component.exports